import React, { useState, useContext, useRef, useEffect } from 'react';
import { Grid, IconButton, useMediaQuery, useTheme } from '@material-ui/core';
import { Storefront } from '@material-ui/icons';
import { Link, useHistory } from 'react-router-dom';

import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import MenuIcon from '@material-ui/icons/Menu';
import MenuOpenIcon from '@material-ui/icons/MenuOpen';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import LoyaltyIcon from '@material-ui/icons/Loyalty'; // Promocoes
import PeopleIcon from '@material-ui/icons/People';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import StorageIcon from '@material-ui/icons/Storage';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import BuildIcon from '@material-ui/icons/Build';
import EventIcon from '@material-ui/icons/Event';
import BusinessIcon from '@material-ui/icons/Business';

import useStorage from '../../../utils/useStorage';
import MainSlideItens from './Itens/slideItens';
import UILogo from '../../UI/Logo/UILogo';
import StoreContext from '../../Store/context';
import MainSlidePerfil from './Perfil/slidePerfil';
import {
  isAdminUser,
  isManagerOrAbove,
  hasAccessCode,
} from '../../../utils/permissionUtils';

import './slide.css';
import ErrorNoAutentication from '../../Error/NoAutentication/ErrorNoAutentication';
import { useFirebaseAuth } from '../../../contexts/FirebaseAuthContext';

const MainSlide = () => {
  const [open, setOpen] = useState(false);
  const {
    credencials,
    setCredencials,
    chatbotOpen,
    setChatbotOpen,
    chatbotUnreadCount,
  } = useContext(StoreContext);
  const { logout } = useFirebaseAuth();
  const [, , remove] = useStorage('credencials');
  const history = useHistory();

  const isAdmin = isAdminUser(credencials);
  const isManager = isManagerOrAbove(credencials);
  const hasDuxiaAccess = Boolean(credencials);

  // Check if is mobile
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Hide menu if click outside
  const navBarRef = useRef(null);
  useEffect(() => {
    const pageClickEvent = (e) => {
      if (!navBarRef.current || !isMobile) return;
      if (
        !navBarRef.current.contains(e.target) &&
        e.target?.id !== 'main-base__slide-itens'
      ) {
        document.getElementById('main-base__slide-itens').click();
        toggleSlide();
      }
    };
    if (open) {
      window.addEventListener('click', pageClickEvent);
    }
    return () => {
      window.removeEventListener('click', pageClickEvent);
    };
  }, [open]);

  // Retrai a barra lateral automaticamente quando o chatbot da duxIA for aberto
  useEffect(() => {
    if (chatbotOpen) {
      setOpen(false);
      const checkbox = document.getElementById('main-base__slide-itens');
      if (checkbox && checkbox.checked) {
        checkbox.checked = false;
      }
    }
  }, [chatbotOpen]);

  // Sincroniza evento de alteração do checkbox da barra lateral
  useEffect(() => {
    const checkbox = document.getElementById('main-base__slide-itens');
    if (!checkbox) return;
    const handleCheckboxChange = () => {
      if (checkbox.checked) {
        setOpen(true);
        setChatbotOpen(false);
      } else {
        setOpen(false);
      }
    };
    checkbox.addEventListener('change', handleCheckboxChange);
    return () => {
      checkbox.removeEventListener('change', handleCheckboxChange);
    };
  }, [setChatbotOpen]);

  async function removerUser() {
    try {
      if (logout) {
        await logout();
      }
    } catch (err) {
      console.error("Erro ao deslogar do Firebase:", err);
    }
    remove();
    setCredencials(null);
    history.push('/');
  }

  function toggleSlide() {
    const nextOpen = !open;
    setOpen(nextOpen);
    if (nextOpen) {
      // Ao expandir a barra, fecha o chatbot automaticamente
      setChatbotOpen(false);
    }
  }

  const changeContent = (route) => {
    if (history.location.pathname !== route) {
      history.push(route);
    }
  };

  return (
    <>
      <Grid
        ref={navBarRef}
        container
        direction="column"
        justify="flex-start"
        alignItems="flex-start"
        id="main-base-slide"
        className="main-base-slide__slide"
      >
        <Grid
          container
          direction="row"
          justify={open ? 'space-between' : 'center'}
          alignItems="center"
          className="main-base-slide__toggle-slide"
        >
          {open && (
            <Link to="/home">
              <UILogo size="25px" />
            </Link>
          )}
          <IconButton onClick={toggleSlide}>
            <label htmlFor="main-base__slide-itens">
              <MenuOpenIcon
                fontSize="large"
                className={!open ? 'display-none' : ''}
              />
              <MenuIcon
                fontSize="large"
                className={open ? 'display-none' : ''}
              />
            </label>
          </IconButton>
        </Grid>

        <MainSlidePerfil
          open={open}
          function="Operador de caixa"
          credencials={credencials}
          exit={removerUser}
          icon={<AccountCircleIcon />}
          options={[
            ...(isAdmin
              ? [
                {
                  name: 'Dados da Empresa',
                  action: () => changeContent('/home/gestao/empresa'),
                },
              ]
              : []),
            { name: 'Sair', action: removerUser, exit: true },
          ]}
        />

        <Grid item className="main-base-slide__divider" />

        <MainSlideItens
          open={open}
          name="Caixa"
          icon={<Storefront />}
          options={[
            ...(isManager
              ? [
                {
                  name: 'Novo',
                  action: () => changeContent('/home/caixas/novo'),
                },
              ]
              : []),
            {
              name: 'Pesquisar/ editar',
              action: () => changeContent('/home/caixas/pesquisar'),
            },
            {
              name: 'Abrir/ fechar',
              action: () => changeContent('/home/caixas/detalhes'),
            },
            {
              name: 'Sangria',
              action: () => changeContent('/home/caixas/sangria'),
            },
          ]}
        />
        <MainSlideItens
          open={open}
          name="Clientes"
          icon={<AssignmentIndIcon />}
          options={[
            {
              name: 'Novo',
              action: () => changeContent('/home/clientes/novo'),
            },
            {
              name: 'Pesquisar/ editar',
              action: () => changeContent('/home/clientes/pesquisar'),
            },
            ...(isManager
              ? [
                {
                  name: 'Perfis Customizados',
                  action: () => changeContent('/home/clientes/perfis'),
                },
              ]
              : []),
            // {
            //   name: 'Agenda',
            //   action: () => changeContent('/home/agendamentos/agenda'),
            // },
          ]}
        />
        <MainSlideItens
          open={open}
          name="Vendas"
          icon={<AddShoppingCartIcon />}
          options={[
            ...(!isMobile
              ? [
                  {
                    name: 'Modo PDV',
                    action: () => {
                      if (!document.fullscreenElement) {
                        document.documentElement.requestFullscreen().catch(() => {});
                      }
                      changeContent('/pdv');
                    },
                  },
                ]
              : []),
            {
              name: 'Nova',
              action: () => changeContent('/home/vendas/nova'),
            },
            {
              name: 'Pesquisar/ editar',
              action: () => changeContent('/home/vendas/pesquisar'),
            },
            {
              name: 'Pagamentos',
              action: () => changeContent('/home/vendas/pagamentos'),
            },
            {
              name: 'Comandas',
              action: () => changeContent('/home/vendas/comanda'),
            },
          ]}
        />
        <MainSlideItens
          open={open}
          name="Produtos"
          icon={<StorageIcon />}
          options={[
            ...(isManager
              ? [
                {
                  name: 'Novo',
                  action: () => changeContent('/home/produto/novo'),
                },
              ]
              : []),
            {
              name: 'Pesquisar/ editar',
              action: () => changeContent('/home/produto/pesquisar'),
            },
            ...(isManager
              ? [
                {
                  name: 'Categorias',
                  action: () => changeContent('/home/categoria/nova/p'),
                },
              ]
              : []),
          ]}
        />
        <MainSlideItens
          open={open}
          name="Serviços"
          icon={<BuildIcon />}
          options={[
            ...(isManager
              ? [
                {
                  name: 'Novo',
                  action: () => changeContent('/home/servico/novo'),
                },
              ]
              : []),
            {
              name: 'Pesquisar/ editar',
              action: () => changeContent('/home/servico/pesquisar'),
            },
            ...(isManager
              ? [
                {
                  name: 'Categorias',
                  action: () => changeContent('/home/categoria/nova/s'),
                },
              ]
              : []),
          ]}
        />
        <MainSlideItens
          open={open}
          name="Usuários"
          icon={<PeopleIcon />}
          options={[
            isManager && {
              name: 'Novo',
              action: () => changeContent('/home/usuarios/novo'),
            },
            {
              name: 'Pesquisar/ editar',
              action: () => changeContent('/home/usuarios/pesquisar'),
            },
          ].filter(Boolean)}
        />
        <MainSlideItens
          open={open}
          name="Promoções"
          icon={<LoyaltyIcon />}
          options={[
            ...(isManager
              ? [
                {
                  name: 'Nova',
                  action: () => changeContent('/home/promocao/nova'),
                },
              ]
              : []),
            {
              name: 'Pesquisar/ editar',
              action: () => changeContent('/home/promocao/pesquisar'),
            },
            ...(isManager
              ? [
                {
                  name: 'Perfis Promocionais',
                  action: () => changeContent('/home/clientes/perfis'),
                },
              ]
              : []),
          ]}
        />
        {isManager && (
          <MainSlideItens
            open={open}
            name="Gestão"
            icon={<TrendingUpIcon />}
            options={[
              {
                name: 'Visão Geral',
                action: () => changeContent('/home/gestao/visaogeral'),
              },
              {
                name: 'Planejamento',
                action: () => changeContent('/home/gestao/planejamento'),
              },
              {
                name: 'Contas a pagar',
                action: () => changeContent('/home/gestao/contas'),
              },
              {
                name: 'Contas a receber',
                action: () => changeContent('/home/vendas/pesquisar'),
              },
              {
                name: 'Custos',
                action: () => changeContent('/home/gestao/custos'),
              },
              {
                name: 'Estoque',
                action: () => changeContent('/home/gestao/estoque'),
              },
              {
                name: 'Ajustes Administrativos',
                action: () => changeContent('/home/gestao/ajustes'),
              },
              {
                name: 'Livros de Caixa',
                action: () => changeContent('/home/caixas/fechamentos'),
              },
              ...(isAdmin
                ? [
                  {
                    name: 'Catálogo Online',
                    action: () => changeContent('/home/gestao/catalogo'),
                  },
                  {
                    name: 'Dados da Empresa',
                    action: () => changeContent('/home/gestao/empresa'),
                  },
                ]
                : []),
            ]}
          />
        )}

        {/* Bottom section: DuxIA + Sair */}
        {open ? (
          <>
            <Grid item className="main-base-slide__divider" />
            <Grid
              container
              direction="row"
              justify="space-around"
              alignItems="center"
              style={{ padding: '8px 0' }}
            >
              {hasDuxiaAccess && (
                <Grid
                  item
                  className="main-base-slide-item__item duxia-nav-item"
                  onClick={() => setChatbotOpen((prev) => !prev)}
                  style={{
                    cursor: 'pointer',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 2,
                    position: 'relative',
                  }}
                  title={chatbotUnreadCount > 0 ? `duxIA (${chatbotUnreadCount} mensagens não lidas)` : 'duxIA - Assistente Executiva'}
                >
                  <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                    <img
                      src="/image/duxia.jpg"
                      alt="DuxIA"
                      className={chatbotUnreadCount > 0 ? 'duxia-avatar-pulse' : ''}
                      style={{
                        width: 30,
                        height: 30,
                        borderRadius: '50%',
                        objectFit: 'cover',
                        border: '2px solid #17497f',
                        transition: 'all 0.2s ease',
                      }}
                    />
                    {chatbotUnreadCount > 0 && (
                      <span className="duxia-sidebar-badge">
                        {chatbotUnreadCount}
                      </span>
                    )}
                  </div>
                  <span
                    style={{
                      fontSize: 11,
                      fontWeight: chatbotUnreadCount > 0 ? 700 : 500,
                      color: chatbotUnreadCount > 0 ? '#17497f' : '#555',
                      transition: 'color 0.2s ease',
                    }}
                  >
                    DuxIA
                  </span>
                </Grid>
              )}
              <MainSlideItens
                open={open}
                exit={removerUser}
                name="Sair"
                icon={<ExitToAppIcon />}
              />
            </Grid>
          </>
        ) : (
          /* Collapsed: show DuxIA icon below nav items */
          hasDuxiaAccess && (
            <>
              <Grid item className="main-base-slide__divider" />
              <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
                style={{ padding: '10px 0', cursor: 'pointer' }}
                onClick={() => setChatbotOpen((prev) => !prev)}
                title={chatbotUnreadCount > 0 ? `duxIA (${chatbotUnreadCount} mensagens não lidas)` : 'duxIA - Assistente Executiva'}
              >
                <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                  <img
                    src="/image/duxia.jpg"
                    alt="DuxIA"
                    className={chatbotUnreadCount > 0 ? 'duxia-avatar-pulse' : ''}
                    style={{
                      width: 28,
                      height: 28,
                      borderRadius: '50%',
                      objectFit: 'cover',
                      border: chatbotUnreadCount > 0 ? '2px solid #17497f' : '2px solid transparent',
                      opacity: chatbotUnreadCount > 0 ? 1 : 0.8,
                      transition: 'opacity 0.2s, border 0.2s',
                    }}
                    onMouseEnter={(e) => (e.target.style.opacity = 1)}
                    onMouseLeave={(e) => (e.target.style.opacity = chatbotUnreadCount > 0 ? 1 : 0.8)}
                  />
                  {chatbotUnreadCount > 0 && (
                    <span className="duxia-sidebar-badge">
                      {chatbotUnreadCount}
                    </span>
                  )}
                </div>
              </Grid>
            </>
          )
        )}
      </Grid>
      <ErrorNoAutentication allowRelogin />
    </>
  );
};

export default MainSlide;

